export const wallboardsSelector = (state) => state.controls.wallboards;
export const scorecardsSelector = (state) => state.controls.scorecards;
export const dashboardSelector = (state) => state.controls.dashboard;
export const gamificationSelector = (state) => state.controls.gamification;
